import { compose, prop } from 'ramda';

const questionToHTMLId: (q: Record<'id', number>) => string = compose(
  (id) => `collection-question-${id}`,
  prop<'id', number>('id')
);

export { questionToHTMLId };
